import {
  Box,
  Grid,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import "./style.css";

const ConteudoModalCorrenteReversa = () => {
    return (
        <>
            <DialogTitle id="alert-dialog-title">Atenção!</DialogTitle>
            <DialogContent className="content-corrente-reversa">
                <Grid container>
                    <Grid size={12}>
                        <Grid size={12}>
                            <Box component="h4" className="subtitle-modal">Risco de corrente reversa identificado!</Box>
                            <Box component="p">Consulte o material abaixo na biblioteca para entendimento e orientação!</Box>
                            <Box component="p">[Documento Biblioteca - <strong>Proteção Contra Sobrecorrente no Inversor</strong>]</Box>
                            <Box component="p">Caso opte por seguir com um cenário que não atenda o requisito técnico, a Intelbras se reserva o direito de não garantir o funcionamento do sistema, podendo recusar a cobertura da garantia em caso de falhas decorrentes dessa incompatibilidade.</Box>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </>
    );
};

export { ConteudoModalCorrenteReversa };
